import {debounce} from "./debounce";

/**
 * Parallax (FC)
 * @type {NodeListOf<Element>}
 */
const parallax = (parallaxes) => {
    if (!parallaxes || Number.parseInt(parallaxes.length, 10) === 0) {
        return;
    }
    document.addEventListener("DOMContentLoaded", () => {
        let options = {
            root: null,
            rootMargin: "0px 0px",
            threshold: 0.05,
        };
        let observer = new IntersectionObserver(beTouching, options);
        parallaxes.forEach(item => {
            observer.observe(item);
        });
    });

    function beTouching(entries, ob) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("active");
                //ob.unobserve(entry.target);
            } else {
                entry.target.classList.remove("active");
            }
        });
    }

    const handleParallaxScroll = () => {
        let parallaxItems = document.querySelectorAll('.parallax.active .parallax__item');
        parallaxItems.forEach((item) => {
            let dataParallax = item.getBoundingClientRect().top / item.dataset.parallax + 'px';
            item.style.transform = 'translate3d(0, ' + dataParallax + ', 0)';
        });
    }
    handleParallaxScroll();
    const onScroll = debounce(() => handleParallaxScroll(), 6);
    window.addEventListener("scroll", onScroll);
}
export default parallax;
